export default "__VITE_ASSET__fS4QBijw__"